var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "-50 -50 100 100",
    id: "loading",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #loading > .spinner {\n      animation: offset 2s ease-in-out reverse infinite,\n        rotate 4s linear forwards infinite;\n      stroke-dasharray: 141.391;\n    }\n    @keyframes offset {\n      0% {\n        stroke-dashoffset: 0;\n      }\n      90% {\n        stroke-dashoffset: 282.782;\n      }\n      100% {\n        stroke-dashoffset: 282.782;\n      }\n    }\n    @keyframes rotate {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(-360deg);\n      }\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "spinner",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 10,
    d: "       M -45 0       A 45 45 0 0 0 45 0     "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "spinner",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 10,
    d: "       M 45 0       A 45 45 0 0 0 -45 0     "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.8627dad5.svg";
export { ForwardRef as ReactComponent };